import { createAction } from '@reduxjs/toolkit';
export const MUTE_CONFERENCE_PARTICIPANT = 'MUTE_CONFERENCE_PARTICIPANT';
export const muteConferenceParticipantAction = createAction(MUTE_CONFERENCE_PARTICIPANT);